import React, { useEffect } from "react";
import Card from "components/card";
import { Form, Input, Select } from 'antd';
import FormItem from "components/fields/FormItem";
import TextAreaField from "components/fields/TextAreaField";
import { connect } from "react-redux";
import { 
	getAccountDetails, doAccountCreate, doAccountUpdate 
} from "../../../../redux/account/accountState";
import { useForm } from 'antd/lib/form/Form';
import CrudButtons from "components/button/crudbuttons";
import { requiredField } from '../../../../utils/crudSagaHelper';
import { renderLabel } from '../../../../utils/index';

const AccountForm = ({getRecord, doCreate, doUpdate, recordData, requesting, success, ...props}) => {
	
  	const { recordId, mode } = props;  	
  	const [form] = useForm();
  	
  	useEffect(() => {
        getRecord(recordId);
	}, [recordId, getRecord]);
	
	useEffect(() => {
		if(recordData){
			const { ...restData } = recordData;
	        const initialValues = {
	            ...restData,	            
	        };
			
	        form.setFieldsValue(initialValues);
        }
    }, [recordData, form]);
    
  	const onSubmit = (formData) => {	
    	try {  
			formData.is_menu = formData.is_menu === false ? 0 : formData.is_menu;
			formData.is_active = formData.is_active === false ? 0 : formData.is_active;
			recordData.id > 0 ? doUpdate(formData): doCreate(formData); 
    	} catch (error) {
      		console.error('Save failed:', error);
    	}
  	};
  
  	return (
    	<Card extra={"w-full h-full p-4"}>
		  	<Form form={form} className="form"
		  		layout="vertical"
		  		onFinish={onSubmit}
	        >   
	        	<FormItem
			        name="id"
			        hidden
			    >
			        <Input type="hidden"/>
			    </FormItem>
        		<div className="form-column-4">         
		            <FormItem 
		            	name="code"
		                label="Code"
		                rules={[requiredField()]}
		            >
		            	{mode === 'edit' ?
		            	<Input id="code"
		            		maxLength={20}		            		
		            	/>
		            	: renderLabel(recordData?.code)
		            	}	                
	            	</FormItem>	
					<FormItem extra="col-span-1 md:col-span-2"
		            	name="name"
		                label="Name"
		                rules={[requiredField()]}
		            >
		            	{mode === 'edit' ?
		            	<Input id="name"
		            		maxLength={50}		            		
		            	/>
		            	: renderLabel(recordData?.name)
		            	}	                
	            	</FormItem>
					<FormItem 
						name="status_id"
						label="Status"
						rules={[requiredField()]}
					>
						{mode === 'edit' ?
						<Select id="status_id"
							allowClear={true}
							options={recordData?.statusOptions}
						/>					
						: renderLabel(recordData?.status_id === 1 ? 'Active' : 'Inactive')
						}                
					</FormItem>
					<FormItem extra="col-span-1 md:col-span-3 xl:col-span-4"
						name="description"
						label="Profile Summary"
					>
						{mode === 'edit' ?
						<TextAreaField id="description"
							maxLength={1000}
						/>	
						: renderLabel(recordData?.description)
						}					
					</FormItem>            	            		            	 
					
	 			</div>
	 			<CrudButtons baseRoute="/console/accounts" mode={mode} recordId={recordId} /> 				 			
	 		</Form>	 	
	 	</Card>
  	);
};

const mapStateToProps = (state) => ({
  	recordData: state.account.details?.data,
  	requesting: state.account.details?.requesting,
  	success: state.account.details?.succcess,
});

const mapDispatchToProps = (dispatch) => ({
	getRecord: (id) => dispatch(getAccountDetails(id)),
  	doCreate: (data) => dispatch(doAccountCreate(data)),
  	doUpdate: (data) => dispatch(doAccountUpdate(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AccountForm);
